/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import H1 from '../../components/H1';
import H2 from '../../components/H2';
import Row from '../../components/Row';
import IconUrlDino from '../../images/nodi/nodiDefault.svg';
import messages from './messages';

const LogoDino = styled.img`
  ${tw`mr-def sm:mr-abs8`};
`;

const Container = styled.div`
  ${tw`md:flex-row pt-def sm:pt-abs10`};
`;

const CustomH2 = styled(H2)`
  ${tw`text-left w-4/5
    sm:m-gutter`};
`;

type NotFoundProps = {
  statusCode?: number;
  location?: string;
};

export default function NotFound(props: NotFoundProps) {
  const { location, statusCode } = props;

  return (
    <Container>
      <Helmet>
        <meta
          content={statusCode?.toString() || '404'}
          name="prerender-status-code"
        />
        {location && (
          <meta content={`Location: ${location}`} name="prerender-header" />
        )}
      </Helmet>
      <Row>
        <H1>
          <LogoDino alt="mascott" src={IconUrlDino} />
          <FormattedMessage {...messages.header} />
        </H1>
        <CustomH2>
          <FormattedMessage {...messages.subHeader} />
        </CustomH2>
      </Row>
    </Container>
  );
}
